import { z } from 'zod';
import {
    APPLICABILITY_DOMAIN_KEYS,
    APPLICABILITY_VALUE_APPLICABLE,
    APPLICABILITY_VALUE_NOT_APPLICABLE,
} from './measure-applicability.constants.js';

const objectIdSchema = z.string().min(1);

export const ApplicabilityValueSchema = z.enum([
    APPLICABILITY_VALUE_APPLICABLE,
    APPLICABILITY_VALUE_NOT_APPLICABLE,
]);

const applicabilityShape = Object.fromEntries(
    APPLICABILITY_DOMAIN_KEYS.map((key) => [
        key,
        ApplicabilityValueSchema.nullable().optional(),
    ]),
);

export const ApplicabilityMapSchema = z.object(applicabilityShape);

export const MeasureApplicabilitySchema = z.object({
    id: objectIdSchema.optional(),
    evaluationId: objectIdSchema,
    assetGroupId: objectIdSchema,
    assetGroupName: z.string().optional(),
    assetGroupNo: z.string().optional(),
    category: z.string().optional(),
    criticalityDegree: z.union([z.literal(1), z.literal(2), z.literal(3)]),
    applicability: ApplicabilityMapSchema,
    createdAt: z.string().optional(),
    updatedAt: z.string().optional(),
});

export const UpdateMeasureApplicabilitySchema = z.object({
    applicability: ApplicabilityMapSchema,
});
